// Array extension to filter out null and undefined values
declare global {
  // eslint-disable-next-line orn/interface-prefix
  interface Array<T> {
    filterNullish(): NonNullable<T>[];
    chunk(size: number): T[][];
  }
}

Array.prototype.filterNullish = function <T>(this: T[]): NonNullable<T>[] {
  return this.filter((item): item is NonNullable<T> => item != null);
};

Array.prototype.chunk = function <T>(this: T[], size: number): T[][] {
  if (size <= 0) {
    throw new Error('Chunk size must be greater than 0');
  }
  const chunks: T[][] = [];
  for (let i = 0; i < this.length; i += size) {
    chunks.push(this.slice(i, i + size));
  }
  return chunks;
};

// Export empty object to make this file a module
export {};
